import { IconProps } from "../../utils/global-types/global-types";

const UserIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_2023_7427)">
        <path d="M7.258 7.278h-.517a5.067 5.067 0 0 0-5.061 5.061v.316a1.344 1.344 0 0 0 1.342 1.343h7.955a1.344 1.344 0 0 0 1.343-1.343v-.316a5.067 5.067 0 0 0-5.062-5.061M7 6.158a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16"></path>
      </g>
      <defs>
        <clipPath id="clip0_2023_7427">
          <path fill="#fff" d="M0-.002h14v14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserIcon;
